import { graphql, HttpResponse } from 'msw'

export const getEnrollmentJointVerifyEmailDataMock = {
  errors: null,
  isError: false,
  activePerson: {
    applicationId: '1234567890',
    path: '/enrollment/joint/verify-email',
    progress: 30,
  },
}

export const submitEnrollmentJointVerifyEmailDataMock = {
  errors: null,
  isError: false,
  activePerson: {
    path: '/enrollment/joint/verify-phone',
  },
}

export const submitEnrollmentJointResendEmailDataMock = {
  errors: null,
  isError: false,
  activePerson: {
    applicationId: '1234567890',
    path: '/enrollment/joint/verify-email',
    progress: 30,
  },
}

export const mockGetEnrollmentJointVerifyEmailData = graphql.mutation('getEnrollmentJointVerifyEmailData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointVerifyEmailDataMock } })
})

export const mockSubmitEnrollmentJointVerifyEmailData = graphql.mutation('submitEnrollmentJointVerifyEmailData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointVerifyEmailDataMock } })
})

export const mockSubmitEnrollmentJointResendEmailData = graphql.mutation('submitEnrollmentJointResendEmailData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointResendEmailDataMock } })
})

export const mockEnrollmentJointVerifyEmail = [
  mockGetEnrollmentJointVerifyEmailData,
  mockSubmitEnrollmentJointVerifyEmailData,
  mockSubmitEnrollmentJointResendEmailData,
]
